import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {LayoutService} from './layout.service';

/**
 * The core guard is the main guard of the layout service and enables
 * other modules to globally register their own custom guards without
 * the need to add them to the routing config of all modules.
 *
 * The layout service implements methods to register such guards
 * and also to give them a run priority. This way it is possible
 * to define the run order of registered guards.
 */
@Injectable()
export class CoreGuard implements CanActivate {

  /**
   * Injects the layout service
   *
   * @param {LayoutService} layoutService
   */
  constructor(private layoutService: LayoutService) {}

  /**
   * Executes all registered guards in the given order (priority)
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<boolean> | boolean}
   */
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const guards = this.layoutService.getRegisteredGuards();

    // iterate all registered guards
    for (const guard of guards) {
      if (!guard) {
        continue;
      }

      // execute guard and get result
      const canActivate = await guard.canActivate(route, state);

      if (!canActivate) {
        console.log(`guard:${guard.constructor.name} > canActivate: false`);
        return false;
      }
    }

    return true;
  }
}
